import { SocilaSignInPayload } from "features/auth/models";
import { axiosClient } from "./client";
import {
  REGISTER_VIA_EMAIL,
  RESET_PASSWORD,
  RESET_PASSWORD_EMAIL_SUBMIT,
  RESET_PASSWORD_EMAIL_VERIFY,
  SIGNIN_EMAIL,
  SIGNIN_SOCIAL,
  VERIFY_EMAIL,
  AUTH_USER_GET,
  AUTH_PROFILE,
} from "./client/endpoints";

const signInSocial = async (data: SocilaSignInPayload): Promise<any> => {
  const response = await axiosClient.post<any>(SIGNIN_SOCIAL, data);
  return response.data;
};
const registerUserViaEmail = async (data: any): Promise<any> => {
  const response = await axiosClient.post<any>(REGISTER_VIA_EMAIL, data);
  return response.data;
};

const signinUserViaEmail = async (data: any): Promise<any> => {
  const response = await axiosClient.post<any>(SIGNIN_EMAIL, data);
  return response.data;
};

const verifyEmail = async (data: any): Promise<any> => {
  const response = await axiosClient.get<any>(
    `${VERIFY_EMAIL}?uid=${data?.uid}&code=${data?.code}`
  );
  return response.data;
};

const submitRestPasswordEmail = async (data: any): Promise<any> => {
  const response = await axiosClient.post<any>(
    RESET_PASSWORD_EMAIL_SUBMIT,
    data
  );
  return response.data;
};

const verifyRestPasswordEmail = async (data: any): Promise<any> => {
  const response = await axiosClient.get<any>(
    `${RESET_PASSWORD_EMAIL_VERIFY}?email=${data?.email}&uid=${data?.uid}&code=${data?.code}`
  );
  return response.data;
};

const restPassword = async (data: any): Promise<any> => {
  const response = await axiosClient.post<any>(RESET_PASSWORD, data);
  return response.data;
};

const getAuthUserProfile = async (): Promise<any> => {
  const response = await axiosClient.get<any>(AUTH_PROFILE);
  return response.data;
};

const AuthService = {
  signInSocial,
  registerUserViaEmail,
  signinUserViaEmail,
  verifyEmail,
  submitRestPasswordEmail,
  verifyRestPasswordEmail,
  restPassword,
  getAuthUserProfile,
};

export default AuthService;
